import React from "react";
import Header from "../components/Header";
import PagesHero from "../components/PagesHero";
import LoginSection from "../components/LoginSection";
import FooterSection from "../components/FooterSection";
import NumberCount from "../components/NumberCount";


function Login() {
  return (
    <div>
      <Header />
      <PagesHero page={"login"} />
      <LoginSection />
      <NumberCount />
      <FooterSection />
    </div>
  );
}

export default Login;
